import { render, staticRenderFns } from "./EmptyLayout.vue?vue&type=template&id=7fc3fa6a"
import script from "./EmptyLayout.vue?vue&type=script&lang=js"
export * from "./EmptyLayout.vue?vue&type=script&lang=js"
import style0 from "./EmptyLayout.vue?vue&type=style&index=0&id=7fc3fa6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports